"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _OrganisationMember = _interopRequireDefault(require("../../OrganisationMember/OrganisationMember"));
var _List = _interopRequireDefault(require("../../List/List"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.inapp-specialists-container .inapp-content {\n  display: flex;\n  grid-template-columns: repeat(2, minmax(0, 1fr)); }\n  .inapp-specialists-container .inapp-content .page-accordion-generic-container {\n    width: min-content;\n    flex-grow: 1; }\n  .inapp-specialists-container .inapp-content .presidents {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap; }\n    .inapp-specialists-container .inapp-content .presidents .OrganisationMember-container {\n      margin: initial; }\n\n.list-container {\n  padding-right: 64px; }\n\n@media (max-width: 66rem) {\n  .inapp-specialists-container {\n    padding-bottom: 0px; }\n    .inapp-specialists-container .inapp-content {\n      flex-direction: column; }\n      .inapp-specialists-container .inapp-content .page-accordion-generic-container {\n        width: 100%; }\n    .inapp-specialists-container .presidents {\n      gap: 16px; } }\n\n@media (max-width: 42rem) {\n  .inapp-specialists-container .inapp-content {\n    flex-direction: column; }\n  .inapp-specialists-container .presidents {\n    flex-direction: column;\n    gap: 0px; } }\n";
  const fileName = "InAppSpecialists_InAppSpecialists";
  const element = document.querySelector("style[data-sass-component='InAppSpecialists_InAppSpecialists']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const getImage = async pictureURL => {
  const response = await fetch(pictureURL);
  const picture = await response.json();
  return picture;
};
const Content = _ref => {
  let {
    accordion,
    president,
    translate
  } = _ref;
  const [presidentArray, setPresidentArray] = (0, _react.useState)(president);
  const formatPresidents = async () => {
    const new_array = [];
    for (let i = 0; i < president.length; i++) {
      const element = president[i];
      if (element.image) {
        const image = await getImage(element.image);
        element.picture = image;
      }
      new_array.push({
        ...element
      });
    }
    setPresidentArray(new_array);
  };
  (0, _react.useEffect)(() => {
    formatPresidents();
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "inapp-content"
  }, Object.entries(accordion || {})?.filter(item => item[1])?.map(item => {
    const items = Object.values(item[1])?.map((el, i) => {
      return {
        content: `${el.lastname} ${el.firstname}, ${el.diploma_title ? `${el.diploma_title}, ` : ''}${el.city}`
      };
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "accordion-content",
      key: item[0]
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "item"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "text-container"
    }, /*#__PURE__*/_react.default.createElement(_List.default, {
      title: translate('cms.inapp.professional_groups.' + item[0]),
      items: items,
      variant: 'UNORDERED'
    }))));
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "presidents"
  }, presidentArray?.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, presidentArray.map((president, i) => {
    return /*#__PURE__*/_react.default.createElement(_OrganisationMember.default, _extends({
      key: i
    }, president, {
      professional_group_membership: president.professional_group && president.professional_group[0].name,
      section_memberships: president.sections?.map(group => group.name),
      sia_membership: president.member_type
    }));
  }))));
};
const InAppSpecialists = _ref2 => {
  let {
    translate,
    data
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "inapp-specialists-container sia-padding-02-bottom sia-margin-03-top"
  }, data && /*#__PURE__*/_react.default.createElement(Content, _extends({}, data, {
    translate: translate
  })));
};
var _default = exports.default = InAppSpecialists;